import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
// Models
import { RatingScale } from '@gutwin-audit/shared/models/rating-scale.model';
// Providers
import { PageStatusService } from '@gutwin-audit/shared/services/page-status.service';
import { RatingScalesService } from '@gutwin-audit/shared/services/raiting-scales.service';

@Injectable()
export class RatingScaleResolve implements Resolve<any> {
  constructor(
    private pageStatusService: PageStatusService,
    private ratingScalesService: RatingScalesService,
    private translateService: TranslateService,
    private notificationsService: NotificationsService
  ) { }

  resolve(route: ActivatedRouteSnapshot): Promise<RatingScale> {
    const ratingScaleId = route.params['id'];
    return this.ratingScalesService.getRatingScale(ratingScaleId)
      .catch(error => {
        switch (error.status) {
          case 404:
            this.fetchMessage404Translation()
              .then((translation: string) => {
                this.pageStatusService.goTo404(translation);
              });
            break;
        }
        this.fetchErrorTranslation()
          .then((translation: any) => {
            this.notificationsService.error(translation.title, translation.text);
          });
        return undefined;
      });
  }

  fetchMessage404Translation(): Promise<string> {
    return this.translateService.get('GLOBAL.ERROR.NOT_FOUND.RATING_SCALE')
      .toPromise()
      .then((translation: string) => {
        return translation;
      });
  }

  fetchErrorTranslation(): Promise<any> {
    return this.translateService.get([
      'GLOBAL.ERROR.CONNECTION',
      'GLOBAL.ERROR.LOAD_RATINGS'
    ])
      .toPromise()
      .then((translation: Array<string>) => {
        return {
          title: translation['GLOBAL.ERROR.CONNECTION'],
          text: translation['GLOBAL.ERROR.LOAD_RATINGS']
        };
      });
  }
}
